@if (!sus) {
  <div class="content" gnxRtl>
    <router-outlet />
    <router-outlet name="dialog" />
  </div>
}
